import React, { Component } from 'react';
import moment from 'moment';
import { isInteger, renderAutoCompleteSingleSelect, renderCheckBox, renderDateField, renderRadioButtons, renderTextField } from './reduxFields';
import { Field } from 'redux-form';

const monthDay = [];
for (var i = 1;i < 32;i++) {
  monthDay.push({ id: i, value: i.toString() });
}

export default class Recurrence extends Component {
  constructor(props) {
    super(props);
    this.state = {
      byMonth: props.RecurrencePattern.byMonth ? props.RecurrencePattern.byMonth : 'onDay',
      byYear: props.RecurrencePattern.byYear ? props.RecurrencePattern.byYear : 'onDay',
      BYMONTHDAY: '',
      BYSETPOS: '',
      BYDAY: '',
      BYMONTH: '',
      ends: props.RecurrencePattern.endsOn ? props.RecurrencePattern.endsOn : null,
      UNTIL: props.RecurrencePattern.Until ? props.RecurrencePattern.Until : null,
    };
    this.handleDayChange = this.handleDayChange.bind(this);
    this.onSelectOption = this.onSelectOption.bind(this);
    this.onSelectYearlyOption = this.onSelectYearlyOption.bind(this);
    this.handleNewRequest = this.handleNewRequest.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.handleEndChange = this.handleEndChange.bind(this);
  }

  handleDayChange=(e) => {
    var days = this.props.validations;
    var day = e.target.value;
    var index = days.indexOf(day);
    if (index > -1) {
      days.splice(index, 1);
    } else {
      days.push(day);
    }
    this.props.onValidationsChange(days);
  }
  onSelectOption = (e) => {
    this.setState({ byMonth: e.target.value });
  }
  onSelectYearlyOption = (e) => {
    this.setState({ byYear: e.target.value });
  }
  handleNewRequest(input, selectedRecord) {
    // var values = [];
    // if (this.state.byMonth === 'onDay') {
    //   let monthday = `BYMONTH=${this.state.BYMONTH};BYMONTHDAY=${this.state.BYMONTHDAY}`;
    //   values.push(monthday);
    // } else {
    //   let onThe = `BYMONTH=${this.state.BYMONTH};BYSETPOS=${this.state.BYSETPOS};BYDAY=${this.state.BYDAY}`;
    //   values.push(onThe);
    // }
    // this.props.onValidationsChange(values);
    input.onChange(selectedRecord.value);
    this.setState({ [input.name]: selectedRecord.value });
  }
  handleEndChange(input, selectedRecord) {
    input.onChange(selectedRecord.value);
    this.setState({ ends: selectedRecord.value });
  }
  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({
      [input.name]: value,
    });
  }

  renderEvery() {
    return (
      <Field
        name='Every'
        type="text"
        maxLength="2"
        floatingLabelText='Every'
        normalize={isInteger}
        value={this.props.interval}
        onChange={this.props.onIntervalChange}
        component={renderTextField}
      />
    );
  }
  renderHourly() {
    return (
      <div className="row">
        <div className="col-sm-6 hrs every require">
          {this.renderEvery()}
          <span>hour(s)</span>
        </div>
      </div>
    );
  }
  renderDaily() {
    return (
      <div className="row">
        <div className="col-sm-6 hrs every require">
          {this.renderEvery()}
          <span>day(s)</span>
        </div>
      </div>

    );
  }
  renderWeekly() {
    let weeks = [{ id: 'SU', value: 'Sun' }, { id: 'MO', value: 'Mon' }, { id: 'TU', value: 'Tue' }, { id: 'WE', value: 'Wed' }, { id: 'TH', value: 'Thu' }, { id: 'FR', value: 'Fri' }, { id: 'SA', value: 'Sat' }];
    let selectedValues = this.props.validations;
    return (
      <div>
        <div className="row mt-20">
          <div className="col-sm-6 hrs require">
            {this.renderEvery()}
            <span>week(s)</span>
          </div>
        </div>
        <div>
          {
            weeks.map((obj, i) => {
              return (
                <Field key={i} name={obj.id} label={obj.value} checked={selectedValues.includes(obj.id)} onChange={this.handleDayChange} component={renderCheckBox}/>
              );
            })
          }
        </div>
      </div>

    );
  }
  renderMonthly() {
    let weeks = [{ id: 'SU', value: 'Sun' }, { id: 'MO', value: 'Mon' }, { id: 'TU', value: 'Tue' }, { id: 'WE', value: 'Wed' }, { id: 'TH', value: 'Thu' }, { id: 'FR', value: 'Fri' }, { id: 'SA', value: 'Sat' }];
    let setPos = [{ id: 1, value: 'First' }, { id: 2, value: 'Second' }, { id: 3, value: 'Third' }, { id: 4, value: 'Fourth' }, { id: -1, value: 'Last' }];
    let monthOptions = [{ id: 'onDay', value: 'on day' }, { id: 'onThe', value: 'on the' }];
    return (
      <div>
        <div className="row ">
          <div className="col-sm-6 hrs require">
            {this.renderEvery()}
            <span>month(s)</span>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="row mt-20">
              <div className="col-sm-3"><Field name="byMonth" options={monthOptions} selectedValue={this.state.byMonth} onChange={this.onSelectOption} component={renderRadioButtons}/></div>
              <div className="col-sm-9">
                {this.state.byMonth === 'onDay' ?

                  <div className="col-8 require mt-35"><Field className="mona" name="BYMONTHDAY" label="Month day" options={monthDay} handleNewRequest={this.handleNewRequest} component={renderAutoCompleteSingleSelect} /></div>
                  :
                  <div className="row">
                    <div className="col-6 require mt-35">
                      <Field name="BYSETPOS" label="At" options={setPos} handleNewRequest={this.handleNewRequest} component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-6 require mt-35">
                      <Field name="BYDAY" label="Day" options={weeks} handleNewRequest={this.handleNewRequest} component={renderAutoCompleteSingleSelect} />
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderYearly() {
    let months = [{ id: 1, value: 'January' }, { id: 2, value: 'February' }, { id: 3, value: 'March' }, { id: 4, value: 'April' }, { id: 5, value: 'May' }, { id: 6, value: 'June' }, { id: 7, value: 'July' }, { id: 8, value: 'August' }, { id: 9, value: 'September' }, { id: 10, value: 'October' }, { id: 11, value: 'November' }, { id: 12, value: 'December' }];
    let weeks = [{ id: 'SU', value: 'Sun' }, { id: 'MO', value: 'Mon' }, { id: 'TU', value: 'Tue' }, { id: 'WE', value: 'Wed' }, { id: 'TH', value: 'Thu' }, { id: 'FR', value: 'Fri' }, { id: 'SA', value: 'Sat' }];
    let setPos = [{ id: 1, value: 'First' }, { id: 2, value: 'Second' }, { id: 3, value: 'Third' }, { id: 4, value: 'Fourth' }, { id: -1, value: 'Last' }];
    let monthOptions = [{ id: 'onDay', value: 'on' }, { id: 'onThe', value: 'on the' }];
    return (
      <div>
        <div className="row every60">
          <div className="col-sm-3"><Field name="byYear" options={monthOptions} selectedValue={this.state.byYear} onChange={this.onSelectYearlyOption} component={renderRadioButtons}/></div>
          <div className="col-sm-9">
            {this.state.byYear === 'onDay' ?
              <div className="row">
                <div className="col-sm-6 require mt-35">
                  <Field name="BYMONTH" label="Month" options={months} handleNewRequest={this.handleNewRequest} component={renderAutoCompleteSingleSelect} />
                </div>
                <div className="col-sm-6 require mt-35">
                  <Field name="BYMONTHDAY" label="Month day" options={monthDay} handleNewRequest={this.handleNewRequest} component={renderAutoCompleteSingleSelect} />
                </div>
              </div>
              :
              <div className="row">
                <div className="col-sm-4 require mt-35"><Field name="BYSETPOS" label="At" options={setPos} handleNewRequest={this.handleNewRequest} component={renderAutoCompleteSingleSelect} /></div>
                <div className="col-sm-4 require mt-35"><Field name="BYDAY" label="Day" options={weeks} handleNewRequest={this.handleNewRequest} component={renderAutoCompleteSingleSelect} /></div>
                <div className="col-sm-4 require mt-35"><Field name="BYMONTH" label="Month" options={months} handleNewRequest={this.handleNewRequest} component={renderAutoCompleteSingleSelect} /></div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
  handleFieldChange() {
    switch (this.props.rule) {
    case 'HOURLY':
      return (this.renderHourly());
    case 'DAILY':
      return (this.renderDaily());
    case 'WEEKLY':
      return (this.renderWeekly());
    case 'MONTHLY':
      return (this.renderMonthly());
    case 'YEARLY':
      return (this.renderYearly());
    default:
      return null;
    }

  };
  render() {
    const rules = [{ id: 'DAILY', value: 'Daily' }, { id: 'WEEKLY', value: 'Weekly' }, { id: 'MONTHLY', value: 'Monthly' }, 
    // { id: 'YEARLY', value: 'Yearly' }
  ];
    let endsOn = [{ id: 1, value: 'After' }, { id: 2, value: 'On date' }];
    return (
      <div>
        <div className="row mt-20">
          <div className="col-sm-3">
            <Field
              name="Recurrence"
              options = { rules }
              selectedValue = { this.props.rule }
              component={renderRadioButtons}
              onChange = { this.props.onRuleChange }
            />

          </div>
          <div className="col-sm-9 create_appdays">
            { this.handleFieldChange() }
          </div>
        </div>
        <div className="row">

          <div className="col-sm-6 require mt-35">
            <Field
              name="End"
              label="End"
              options={endsOn}
              handleNewRequest={this.handleEndChange}
              component={renderAutoCompleteSingleSelect} />
          </div>
          <div className="col-sm-6 require">
            {this.state.ends === 1 ?
              <Field
                name='COUNT'
                type="text"
                maxLength="2"
                normalize={isInteger}
                floatingLabelText='Count'
                component={renderTextField}
              />
              : this.state.ends === 2 ?
                <Field
                  name='UNTIL'
                  minDate={this.props.recurrenceMinDate || new Date()}
                  onDateChange={this.onDateChange}
                  selected={this.state.UNTIL}
                  locale="en-US"
                  openToYearSelection = {true}
                  placeholder='Until'
                  component={renderDateField}
                />
                : ''
            }
          </div>
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/recurrenceRule.js